import AXIOS from './axiosClient';

class AvailExcelService {
  exportExcel(availSearchRequest) {
    return AXIOS.post('/export/', availSearchRequest, {timeout: 30000});
  }
}

export default new AvailExcelService();